import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { TransportCapacityComponent } from './transport-capacity.component';


const routes: Routes = [
  {
      path: '',
      component: TransportCapacityComponent,
      canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransportCapacityRoutingModule { }
